import { useEffect } from 'react';
import { cn } from '../lib/cn';
import { useStream } from '../stream/StreamProvider';

/**
 * `notice` events (CONTRACTS §5) as toasts. The gateway already ships them as
 * 繁中 toast-ready text, so this renders the message verbatim rather than
 * re-deriving one from the code — the server knows which limit was hit.
 */
export function Toasts(): JSX.Element | null {
  const { state, dispatch } = useStream();
  const notices = state.notices;

  useEffect(() => {
    if (notices.length === 0) return;
    const timers = notices.map((notice) =>
      setTimeout(() => dispatch({ type: 'dismissNotice', id: notice.id }), 8000),
    );
    return () => timers.forEach(clearTimeout);
  }, [notices, dispatch]);

  if (notices.length === 0) return null;

  return (
    <div className="toasts">
      {notices.map((notice) => (
        <div
          key={notice.id}
          className={cn('toast', notice.level !== 'info' && `toast--${notice.level}`)}
          role={notice.level === 'error' ? 'alert' : 'status'}
        >
          <span>{notice.message}</span>
        </div>
      ))}
    </div>
  );
}
